<template>
  <el-cascader
    ref="cascader"
    v-model="cascaderValue"
    :props="cascaderProps"
    class="w100-percent"
    placeholder="请选择区域"
    @change="handleChange"
    :disabled="disabled"
  />
</template>

<script>
import Vue from "vue";

export default {
  name: "areaCascader",
  model: {
    prop: "values", // 自定义属性名
    event: "change" // 自定义事件名
  },

  props: {
    values: {
      type: Array,
      required: true,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    checkStrictly: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      cascaderValue: [],
      cascaderProps: {
        lazy: true,
        value: "code",
        label: "label",
        checkStrictly: this.checkStrictly,
        lazyLoad: (node, resolve) => {
          if (node.root) {
            this.getAreaList({}, resolve);
          } else {
            this.getAreaList({ parentId: node.value }, resolve);
          }
        }
      }
    };
  },

  watch: {
    values: {
      handler(value) {
        this.cascaderValue = [...value];
      },
      deep: true
    }
  },

  methods: {
    /**
     * 获取商品分类数据
     * @param params
     */
    getAreaList(params, resolve) {
      Vue.ajaxGet(this, global.apiUrl + "/area/list", params).then(response => {
        const data = response || [];
        const result = data.map(item => ({
          ...item,
          leaf: !item.hasNext
        }));
        resolve(result);
      });
    },

    handleChange(data) {
      const nodes = this.$refs.cascader.getCheckedNodes();
      this.$emit("change", data);
      this.$emit("changeFull", {
        values: data,
        labels: nodes[0].pathLabels
      });
    }
  }
};
</script>
